(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-block-deluxe"] && !Shopify.designMode) return;
  try {
    
(function() {

  /* ── Carousel ── */
  document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
    var track   = carousel.querySelector('[data-track]');
    var slides  = carousel.querySelectorAll('.fbd-carousel__slide');
    var dots    = carousel.querySelectorAll('[data-dot]');
    var prevBtn = carousel.querySelector('[data-prev]');
    var nextBtn = carousel.querySelector('[data-next]');
    var total   = slides.length;
    var current = 0;
    var timer   = null;

    if (total <= 1) return;

    function goTo(index) {
      current = (index + total) % total;
      track.scrollTo({ left: track.offsetWidth * current, behavior: 'smooth' });
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function startAuto() {
      timer = setInterval(function() { goTo(current + 1); }, 5000);
    }

    function stopAuto() {
      clearInterval(timer);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { stopAuto(); goTo(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { stopAuto(); goTo(current + 1); startAuto(); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAuto();
        goTo(parseInt(dot.dataset.dot));
        startAuto();
      });
    });

    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);

    startAuto();
  });

  /* ── Lazy video (YouTube + Vimeo) ── */
  function injectIframe(wrap) {
    var type = wrap.dataset.videoType;
    var id   = wrap.dataset.videoId;
    var src  = type === 'youtube'
      ? 'https://www.youtube.com/embed/' + id + '?rel=0'
      : 'https://player.vimeo.com/video/' + id;
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = type === 'youtube' ? 'YouTube video' : 'Vimeo video';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    wrap.appendChild(iframe);
  }

  var lazyWraps = document.querySelectorAll('.fbd-video-lazy');

  if ('IntersectionObserver' in window) {
    var videoObs = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          injectIframe(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '600px' });

    lazyWraps.forEach(function(wrap) {
      videoObs.observe(wrap);
    });
  } else {
    lazyWraps.forEach(function(wrap) {
      injectIframe(wrap);
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-deluxe"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
